import script from "./CustomToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomToggle.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle});
